export const GET_USERS = 'GET_USERS';